import Sentry from "../utils/sentry";
import apiClient from "./ApiService";

const getJobs = async () => {
  try {
    const response = await apiClient.get("https://xg3n-4mh1-ngd5.n7.xano.io/api:GhPRl4nQ/jobs");
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};

export { getJobs };
